export const SizeClasses = {
  xs: 'text-2xl',
  sm: 'text-3xl',
  base: 'text-4xl',
  lg: 'text-4xl',
  xl: 'text-5xl',
  '2xl': 'text-6xl',
  '3xl': 'text-7xl',
  '4xl': 'text-8xl',
}

export const SizeResponsiveClasses = {
  xs: 'lg:text-3xl',
  sm: 'lg:text-4xl',
  base: 'lg:text-5xl',
  lg: 'lg:text-6xl',
  xl: 'lg:text-6xl',
  '2xl': 'lg:text-7xl',
  '3xl': 'lg:text-8xl',
  '4xl': 'lg:text-9xl',
}

export const LeadingClasses = {
  none: 'leading-none',
  tight: 'leading-tight',
}
